import React from 'react';
import { useNavigate } from 'react-router-dom';
import constants from '../config/consts';
import '../styles/CardsCard.css';

const CardsCard = ({ product, onClick }) => {
  const navigate = useNavigate();
  
  // Первое изображение из строки images (разделены запятой) или preViewImg
  const firstImage = product.images?.split(',')[0] || product.preViewImg;

  return (
    <div className="CardsCard" onClick={onClick}>
      <div className="cardsCardImageContainer">
        <img className='cardsCardImage'
          src={`${constants.serverUrl}${firstImage}`} 
          alt={product.title} 
        />
      </div>
      <p className="cardsCardTitle">{product.title}</p>
    </div>
  );
};

export default CardsCard;